
import React, { useState } from 'react';
import { Separator } from '@/components/ui/separator';
import { Button } from '@/components/ui/button';
import { Plus, Eye, EyeOff, Code } from 'lucide-react';
import { Badge } from '@/components/ui/badge';
import { Switch } from '@/components/ui/switch';
import { useToast } from '@/hooks/use-toast';
import ApiKeyItem from '../components/ApiKeyItem';

interface ApiKeysTabProps {
  editing: boolean;
}

const ApiKeysTab: React.FC<ApiKeysTabProps> & { Icon: typeof Code } = ({ editing }) => {
  const [showApiKey, setShowApiKey] = useState(false);
  const { toast } = useToast();
  
  const handleCopyApiKey = () => {
    navigator.clipboard.writeText("sk_test_api_key_example_12345");
    toast({
      title: "API Key Copied",
      description: "The API key has been copied to your clipboard."
    });
  };
  
  return (
    <div className="space-y-4">
      <div className="flex items-center justify-between space-x-2">
        <div className="space-y-0.5">
          <h3 className="font-medium text-lg">API Keys</h3>
          <p className="text-muted-foreground text-sm">
            Manage API keys for external integrations
          </p>
        </div>
        {editing && (
          <Button variant="outline" size="sm" className="gap-1">
            <Plus className="h-4 w-4" />
            Create Key
          </Button>
        )}
      </div>
      
      <Separator />
      
      <div className="space-y-4">
        <ApiKeyItem 
          name="Primary API Key"
          createdDate="April 5, 2025"
          apiKey="sk_test_api_key_example_12345"
          keyType="Production"
          editing={editing}
          showApiKey={showApiKey}
          onToggleVisibility={() => setShowApiKey(!showApiKey)}
          onCopyApiKey={handleCopyApiKey}
        />
        
        {!editing && (
          <div className="border rounded-md border-dashed p-6 flex items-center justify-center">
            <Button variant="outline" disabled={!editing} className="gap-1">
              <Plus className="h-4 w-4" />
              Generate New API Key
            </Button>
          </div>
        )}
      </div>
    </div>
  );
};

ApiKeysTab.Icon = Code;

export default ApiKeysTab;
